export default "__VITE_ASSET__6hLwPBtC__"